import { defineComponent as _defineComponent } from 'vue'
export type BubbleType = 'is-danger' | 'is-warning' | 'is-info';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionBubble',
  props: {
    label: { default: '' },
    type: { default: 'is-info' },
    active: { type: Boolean, default: true }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {





return { __sfc: true,emit }
}

})